import { http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';

class PerformancesActionLogService {
   async getPerformancesActionLog(contractId: number, query: LocationQuery) {
      return http.get(`/contracts/${contractId}/performances-action-logs`, { params: { ...query } }).then((response) => response.data);
   }
}

export { PerformancesActionLogService };
